
import { Nachbestellung, NachbestellungStatus } from "mangdto"
import Component, { mixins } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "./ArtikelRow.vue"
import { EnumFormatter } from "mangutil"

@Component({ components: { ArtikelRow } })
export default class NachbestellungSheet extends mixins(Calculator) {
  @Prop({ required: true }) nachbestellung: Nachbestellung

  formatiereStatus() {
    return EnumFormatter.formatNachbestellungStatus(this.nachbestellung.status)
  }
}
